const HomeIcon = ({ size = 22 }) => (
  <svg width={size} height={size} fill="none" viewBox="0 0 24 24">
    <path d="M3 11.5L12 4l9 7.5V20a2 2 0 0 1-2 2h-4v-6h-6v6H5a2 2 0 0 1-2-2V11.5z" stroke="#1976d2" strokeWidth="2" strokeLinejoin="round"/>
  </svg>
);
export default HomeIcon;